/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiARewindBackIcon20Solid = forwardRef('MediaUiARewindBackIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7.583 3.368.639 8.734a1.6 1.6 0 0 0 0 2.532l6.944 5.366c.986.762 2.417.06 2.417-1.187v-3.9l6.583 5.087c.986.762 2.417.06 2.417-1.187V4.555c0-1.246-1.431-1.949-2.417-1.187L10 8.455v-3.9c0-1.246-1.431-1.949-2.417-1.187Z" })));
});
